import { HTMLAttributes } from 'react';
import { CardTitle } from '@/shared/ui/core';


export function RegistrationCardTitle ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
    return (
        <CardTitle
            as='h1'
            className={ className }
            data-template="registration-card-title"
            { ...props }
        />
    );
}
